import { usePage } from '@inertiajs/vue3'
import type { SharedProps } from '../types'

/**
 * Builds URLs for images and other static files.
 *
 * The base URL comes from a prop shared with every page rather than being
 * hardcoded, so the same code produces correct URLs whichever domain the
 * deployment is served from.
 */
export function useAsset() {
    const page = usePage<SharedProps>()

    /** The full URL of a file, given its path within the assets directory. */
    function asset(path: string): string {
        return page.props.assetUrl + (path.startsWith('/') ? path : `/${path}`)
    }

    /**
     * The URL of a record's image at a given size.
     *
     * Images are stored as "name@1x.ext" and the size is substituted in, so
     * "2x" gives the copy for high-resolution screens and "og" the crop used
     * when a page is shared on social media. This
     * mirrors the imagePath() methods on the PHP models — the two have to
     * agree, since either side may build the URL.
     */
    function modelImage(directory: string, image: string, size: string): string {
        return asset(`/images/${directory}/${image.replace('1x', size)}`)
    }

    return {
        asset,
        modelImage,
    }
}
